export function initLoginModalScripts(parent) {

    const authForm = $(parent).find(".authform form")
    const errorBlock = $(parent).find(".auth-errors")

    jQuery.validator.addMethod("isEmailValid", function (value, element) {
        var re =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(value);
    })

    $(parent).find('.authform .input-ui.password .svg-not-see, .authform .input-ui.password .svg-see').click(function () {

        var parent = $(this).parent().parent();
        var input = parent.find('input');

        parent.toggleClass('open-for-see');

        if (parent.hasClass('open-for-see')) {
            input.attr('type', 'text');
        } else {
            input.attr('type', 'password');
        }

    })

    authForm.validate({
        submitHandler: function (form) {

            const formData = {
                LOGIN: $(form).find("#authlogin").val(),
                PASSWORD: $(form).find("#authpassword").val(),
                sessid: $(form).find("input[name='sessid']").val()
            };

            $.ajax({
                type: "POST",
                url: "/local/ajax/login.php",
                data: formData,
                dataType: "json",
                encode: true,
            }).done(function (data) {
                console.log(data)
                if (data.success === "Y") {
                    window.location.href = "/personal/orders/"
                } else {
                    errorBlock.text(data.error)
                    console.log(data.error)
                }
            }).fail(function (res, exception) {
                console.log(res);
            });
        },
        rules: {
            "USER_LOGIN": {
                required: true,
                isEmailValid: true,
                email: true,
            },
            "USER_PASSWORD": {
                required: true,
                minlength: 8,
            },
        },
        errorPlacement: function(error, element) {
            if(element.attr("type") === "password") {
                error.appendTo( element.parent().parent());
            } else {
                error.appendTo( element.parent());
            }
        },
        messages: {
            "USER_PASSWORD": {
                required: "Обязательное поле",
                minlength: "Пожалуйста, введите не менее 8 символов"
            },
            "USER_LOGIN": {
                required:
                    "Обязательно заполнить. Логином должен быть ваш действующий адрес эл.почты.",
                email:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
                isEmailValid:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
            },
        },
        focusInvalid: true
    })

};
